var map = {
	"./2k23-tpc-sawgrass-17.jpg": 6201,
	"./augusta-national-hero.jpg": 9985,
	"./awards-hero.jpg": 1762,
	"./birdie-challenge-hero.jpg": 6867,
	"./cold-weather-hero.jpg": 5942,
	"./dove-valley-ranch-hero.jpg": 801,
	"./fall-golf-hero.jpg": 4793,
	"./full-swing-hero.jpg": 2181,
	"./reboot-hero.jpg": 529,
	"./rory-vs-greg-hero.jpg": 9290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5661;